import { QueryClient, QueryCache } from '@tanstack/react-query';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (_error, query) => {
      queryClient.setQueryData(query.queryKey, undefined);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,   // data is fresh for 2 min — serves from cache on navigation back
      gcTime: 10 * 60 * 1000,     // keep unused data in memory for 10 min before garbage collection
      retry: 0,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
